<script>
	import { api } from "./../libs/api.js";
	import { _ } from 'svelte-i18n';

	import { Link } from 'svelte-routing';

	import BaseLayer from "./../components/BaseLayer.svelte";

	export let id;

	let excursion = api.get_excursion(id);
	let now = new Date().toISOString();

</script>

<BaseLayer --bg-overlay="url(/assets/bg/mountains.svg)">
	{#await excursion then ex_value}
	{#await api.get_trail(ex_value.data.trail_id) then tr_value}
		<div class="hero aspect-square bg-cover rounded-br-3xl rounded-bl-3xl overflow-hidden drop-shadow-lg"
			style="background-image: url({api.base_url}/assets/{tr_value.data.cover_image});">
		</div>

		<h2 class="page-title text-center py-10">{tr_value.data.translations[0].name}</h2>

		<div class="px-4 mb-10">
			<div class="flex justify-between bg-gray-100 -mx-4 px-14 mb-2 py-2">
				<span>{$_('excursions.date')}</span>
				<span class="text-right font-bold">{new Date(ex_value.data.date).toLocaleDateString()}</span>
			</div>

			<div class="flex justify-between bg-gray-100 -mx-4 px-14 mb-2 py-2">
				<span>{$_('excursions.start')}</span>
				<span class="text-right font-bold">{new Date(ex_value.data.date).toLocaleTimeString()}</span>
			</div>

			<div class="flex justify-between bg-gray-100 -mx-4 px-14 mb-2 py-2">
				<span>{$_('excursions.participants')}</span>
				<span class="text-right font-bold">{ex_value.data.participants.length}</span>
			</div>
				
			<h3 class="page-title mt-10">{$_('excursions.additional_info')}</h3>
			<p class="rich-content">{@html ex_value.data.info}</p>
		</div>

		<div class="text-center mb-8">
			<Link class="btn btn-accent btn-outline w-72 font-bold text-md mt-3 rounded-3xl" to="excursions/{id}/backpack">{$_('excursions.prepare_backpack')}</Link>
			<Link class="btn btn-accent w-72 font-bold text-md mt-3 rounded-3xl" to="trails/{ex_value.data.trail_id}">{$_('excursions.view_trail')}</Link>

			{#if ex_value.data.date < now}
				<Link class="btn btn-accent btn-outline w-72 font-bold text-md mt-3 rounded-3xl" to="excursions/{id}/feedback">{$_('excursions.give_feedback')}</Link>
			{/if}
		</div>
	{/await}
	{/await}
</BaseLayer>

